<div [formGroup]="form" class="wrapper--input">
  <ark-icon
    class="search-icon"
    icon="system-search"
    [color]="iconColor"
    [size]="iconSize"
    (click)="toggle()"
  ></ark-icon>
  <input
    #input
    class="input"
    [type]="type"
    [class.error]="form.dirty && form.invalid"
    [placeholder]="placeholder"
    formControlName="formValue"
    [placeholder]="label"
    [class.expanded]="expanded"
  />
  <label
    [class.input-error-label]="form.dirty && form.invalid"
    [class.expanded]="expanded"
    >{{ label }}</label
  >
  <ark-icon
    class="system-close"
    [icon]="closeIcon"
    [size]="closeIconSize"
    [color]="closeIconColor"
    (mousedown)="clear($event)"
  ></ark-icon>
</div>
